export default __webpack_public_path__ + "static/thumb-landscape-eb8fdb7dcb15885c21b413898bd619da.jpg";